import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiInteractiveQuoteFormCallToAction' })(
  ({ brandColors, breakpoints, type, typography }) => ({
    page: {
      minHeight: '100vh',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    },
    container: {
      display: 'flex',
      flex: 1,
      paddingTop: typography.pxToRem(50),
      [breakpoints.down(ScreenSize.LARGE)]: {
        flexDirection: 'column',
        justifyContent: 'flex-end',
        paddingTop: typography.pxToRem(92),
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        height: 'auto',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        paddingTop: typography.pxToRem(31),
      },
    },
    contentContainer: {
      width: '40%',
      paddingLeft: typography.pxToRem(80),
      paddingRight: typography.pxToRem(60),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [breakpoints.down(ScreenSize.LARGE)]: {
        paddingLeft: typography.pxToRem(50),
        paddingRight: typography.pxToRem(50),
        width: '100%',
        flex: 1,
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(24),
        paddingRight: typography.pxToRem(24),
        justifyContent: 'flex-end',
      },
    },
    rightHalfContainer: {
      height: '100%',
      width: '60%',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [breakpoints.down(ScreenSize.LARGE)]: {
        paddingLeft: typography.pxToRem(39),
        paddingRight: typography.pxToRem(39),
        justifyContent: 'flex-start',
        width: '100%',
        height: '100%',
        marginBottom: typography.pxToRem(60),
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        marginBottom: typography.pxToRem(50),
        paddingLeft: typography.pxToRem(24),
        paddingRight: typography.pxToRem(24),
      },
    },
    heading: {
      ...type['56_medium'],
      color: brandColors.heroBlue,
      marginBottom: typography.pxToRem(35),
      textWrap: 'pretty',
      [breakpoints.down(ScreenSize.LARGE)]: {
        ...type['56_medium'],
        marginBottom: typography.pxToRem(18),
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['44_medium'],
      },
    },
    subheading: {
      color: brandColors.heroBlue,
      fontFamily: 'Roobert',
      fontWeight: 400,
      fontSize: typography.pxToRem(28),
      lineHeight: typography.pxToRem(36),
      letterSpacing: '-0.56px',
      marginBottom: typography.pxToRem(55),
      textWrap: 'pretty',
      [breakpoints.down(ScreenSize.LARGE)]: {
        ...type['24_medium'],
      },
    },
    logo: {
      marginBottom: typography.pxToRem(98),
    },
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      paddingBottom: typography.pxToRem(50),
      [breakpoints.down(ScreenSize.LARGE)]: {
        height: '100%',
        paddingBottom: typography.pxToRem(75),
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {},
    },
  })
);

export default useStyles;
